import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import breakpoints from '../../../../../cra/src/styling/breakpoints';
import { PrimaryDark } from '../../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const ToolbarWrapper = styled.li`
  float: left;
  padding: 0 6px;
  text-align: center;
  height: inherit;
  display: flex;
  align-items: center;
  font-size: 16px;

  &.file-editor,
  &.edit-editor,
  &.insert-editor,
  &.share-editor,
  &.import-document,
  &.download-editor {
    padding: 0 6px;
  }

  &.close-editor {
    padding: 0 6px;
  }

  &.signIn {
    height: 48px;
    padding: 0 0 0 8px;
    @media ${breakpointsMinWidth.tabletMd} {
      padding: 0 0 0 10px;
    }
  }

  &.notifications {
    height: 48px;
    padding: 12px;
    position: relative;

    div.notification {
      z-index: 3;
      top: 48px;
      left: auto;
      right: 0;
    }

    @media ${breakpointsMinWidth.mobileMd} {
      padding: 0 4px;
    }
    @media ${breakpointsMinWidth.tabletMd} {
      padding: 0 12px;
    }
  }

  &.profileIcon {
    padding: 0 0 0 6px;

    &:hover .profile {
      display: block;
    }
  }

  &.defaultProfileIcon {
    padding: 24px 0 24px 16px;
    //TODO: Need to go with a better approach when handling animations - center the rotation
    width: 63px;
    height: 72px;
  }

  /* .profile {
    top: 48px;

    padding: 1rem;
    background-color: #fff;
    border-radius: 0.4rem;
    box-shadow: 0px 2px 10px 1px rgba(41, 49, 89, 0.16);
    z-index: 3;
    right: 0;

    li {
      font-size: 16px;
      color: #333d47;
      text-align: center;
      &:hover {
        background: none;
        color: ${PrimaryDark};
        font-weight: 400;
      }
    }
  } */

  @media ${breakpoints.desktopLg} {
    &.share-editor {
      font-size: 14px;
    }
  }

  @media ${breakpoints.tabletSm} {
    text-align: left;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 8px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 0 6px;
  }

  ${(props) => {
    const { pathname } = props;

    if (pathname && pathname.includes('/documents/'))
      return css`
        padding: 0;

        &.notifications {
          padding: 12px 6px;
          @media screen and (max-width: 1023px) {
            height: 0;
          }

          div.notification {
            border-radius: 2px;
          }
        }

        &.profileIcon {
          padding: 0 0 0 6px;
          height: 48px; // todo: enum
        }

        .profile {
          top: 100%;
          border-radius: 2px;
        }
      `;
    return null;
  }}
`;

const Toolbar = (props) => {
  const { children, className, pathname } = props;
  return (
    <ToolbarWrapper className={className} pathname={pathname}>
      {children}
    </ToolbarWrapper>
  );
};

Toolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
  className: propTypes.string,
};

Toolbar.defaultProps = {
  className: '',
};

export default Toolbar;
